import styled from 'styled-components/native';

const CalendarSheetLeftColumn = styled.View`
  padding: 22px;
  padding-bottom: 0;

  width: 455px;

  flex-grow: 0;

  height: 100%;

  border-right-width: 1px;
  border-right-color: #dddddd;

  gap: 20px;
`;

export default CalendarSheetLeftColumn;
